import { useEffect } from 'react';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
interface MetaPixelWindow extends Window {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
}
export const META_PIXEL_ID = '1313291250496067';

/** Dispara un evento del pixel solo si ya fue inicializado. */
export function trackPixelEvent(event: string): void {
  if (typeof window === 'undefined') return;
  const pixelWindow = window as MetaPixelWindow;
  pixelWindow.fbq?.('track', event);
}
export function MetaPixel() {
  useEffect(() => {
    const pixelWindow = window as MetaPixelWindow;
    if (pixelWindow.fbq) {
      pixelWindow.fbq('track', 'PageView');
      return;
    }
    const fbq = ((...args: unknown[]) => {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
      } else {
        fbq.queue.push(args);
      }
    }) as PixelFunction;
    fbq.queue = [];
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    pixelWindow.fbq = fbq;
    pixelWindow._fbq = fbq;
    if (!document.getElementById('meta-pixel-script')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.id = 'meta-pixel-script';
      document.head.appendChild(script);
    }
    fbq('init', META_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-140" data-mp="1mfsw8d46ogia">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-141" data-mp="1mg2l1xdhshme" />
    </noscript>;
}